import styled from "@emotion/styled";
import { LinearProgress, linearProgressClasses } from "@mui/material";

export const HeaderWrapper = styled.div`
    height: 60px;
    background: #085799;
    position: sticky;
    top:0;
    z-index: 999;
    a {
        color: #ffffff;
        font-size: 1.6rem;
        font-weight: 600;
        text-decoration: none;
        padding: 0 10px;
        font-family: 'Noto Serif', serif !important;
    }

    @media (max-width: 768px) {
        a {
            font-size: 1.1rem;
        }
    }
`

export const HomeSection = styled.div`
    background: linear-gradient(180deg, #085799 0%, #085799 40.81%, #5695C0 100%);
    padding: 40px 0;
    
    h2 {
        color: #fff;
        text-align: center;
        font-size: 2.5rem;
        font-weight: 800;
        margin: 0;
    }

    p {
        color: #fff;
        font-size: 1.2rem;
        line-height: 2rem;
        font-weight: 400;
        margin-bottom: 10px;
    }

    img {
        height: 250px;
        display: block;
        margin-left: auto;
    }

    @media (max-width: 768px) {
        img {
            margin-left: 0;
            width: 100%;
            height: 100%;
        }
    }
`

export const ButtonGrid = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
    button {
        border-radius: 10px;
    }
    .contact-button {
        background: #3FA7FF;
        border: 1px solid #477DA3
    }
    .demo-button {
        background: #0D4F87;
        border: 1px solid #4C80A5;
        margin-right: 20%;
    }

    @media (max-width: 768px) {
        flex-direction: column;

        .demo-button {
            margin-right: 0;
            margin-bottom: 15px;
        }
    }
`

export const IconItems = styled.div`
    display:grid;
    grid-template-columns: repeat(2, 50%);
    margin-top: 30px;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
    }
`

export const IconItem = styled.div`
    height:auto;
    padding:20px 30px;
    margin-bottom:15px;
    margin-right:4%;
    display:flex;
    align-items: center;

    background: #F5F5F5;

    :nth-of-type(2n+0) {
        margin-right:0;
    }
    :nth-of-type(n+3) {
        margin-bottom:0;
    }

    img {
        width: 60px;
        height: auto;
        object-fit: contain;
        margin-right: 20px
    }

    p {
        color: #000000;
        font-size: 1.3rem;
        margin: 0 0 10px 0;
    }
    label {
        font-size: 1rem;
        color: #404040;
    }

    @media (max-width: 768px) {
        margin-right:0;
        margin-bottom: 10px !important;
    }

`

export const IntroSection = styled.div`
    display:grid;
    grid-template-columns: repeat(2, 50%);
    border: 1px solid #F5F5F5;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
    }
`

export const IntroItem = styled.div`
    display: flex;
    align-items: center;
    padding: 20px 10px;
    border: 1px solid #F5F5F5;
    img {
        width: 150px;
    }
    p {
        color: #404040;
        font-size: 1rem;
        line-height: 1.8rem;
    }

    @media (max-width: 768px) {
        margin-bottom: 10px;

        img {
            width: 80px;
        }
    }
`

export const BillreaderSection = styled.div`
    background: #F5F6F9;
    padding: 20px 0;
    margin-top: 40px;
    .intro, .title {
        text-align: center;
        color: #404040;
        font-size: 1.2rem;
    }
    .title {
        font-weight: 400 ;
        font-size: 1.8rem;
    }
    @media (max-width: 768px) {
        display: none;
    }
`

export const Remind = styled.div`
    background: #3FA7FF26;
    border: 1px solid #5BABE0;
    border-radius: 3px;
    width: 100%;
    padding: 15px 10px;
    color: #404040;
`

export const BillWrapper = styled.div`
    border: 1px solid #E4E4E4;
    background: #FFFFFF;
    min-height: 800px;

    h5 {
        font-size: 1.3rem;
        text-align: center;
        margin: 5px 0;
    }

    button {
        text-transform: unset;
    }

`

export const UploadButton = styled.div`
    border: 1px dashed #E4E4E4;
    background: #F7F7F7;
    padding: 15px 10px;
    cursor: pointer;
    img {
        width: 25px;
        display: block;
        margin: 5px auto;
    }

    p {
        font-weight: 500 !important;
        font-size: 1rem;
        text-align: center;
        margin: 5px 0;
        color: #404040;
    }

    label {
        font-weight: 400 !important;
        text-align: center;
        display: block;
        font-size: 0.975rem;
        color: #404040;
    }
`

export const FileItem = styled.div`
    display: flex;
    align-items: center;
    padding: 8px;
    margin: 4px 0;
    background-color: #fff;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #f5f5f5;
        transition: background-color 0.3s;
    }

    button {
        margin-left: auto;
        background: none;
        border: none;
        cursor: pointer;
        color: #666;
        padding: 0 8px;
        font-size: 1.2rem;
    }
`

export const Tips = styled.div`
    text-align: left;
    p {
       color: 000;
       font-weight: bold;
       text-align: left;
       font-size: 1rem;
    }
    span {
        display: block;
        font-weight: 400;
        line-height: 1.5rem;
        color: #404040;
        &::before {
            content: "• "; 
            color: black; 
            font-weight: bold;
            margin-right: 8px;
        }
    }
`

export const CustomLinearProgress = styled(LinearProgress)(({ theme, value }) => ({
    height: 15,
    borderRadius: 10,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: '#F0F0F0', 
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 10,
      backgroundColor: value === 100 ? '#4CAF50' : '#1777FF', 
    },
  }));

export  const StepHeader = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
  h3 {
    margin: 0 10px;
    color: #999;
    font-size: 0.975rem;
    &.active {
      color: #1976d2;
    }
  }
`;

export const StepConnector = styled.div`
  flex: 1;
  height: 2px;
  background: #1976d2;
  margin: 0 10px;
`;

export const ShowFile = styled.div`
  iframe {
    width: 100%;
    height: 720px;
  }

  img {
    max-width: 100%;
    height: 720px;
  }
`

export const TableList = styled.div`
 strong{
    font-size: 1.2rem;
 }
  p {
    text-align: left;
    font-size: 1rem;
  }
`
